<template>
  <div class="details">
    <div class="h5-description">
      <div class="h5-offer-detail">
        <div
          class="h5-offer-detail-header"
        >
          Product Details
        </div>
        <div
          class="h5-offer-image-list"
        >
          <div
            @click="handleImagePreview(index)"
            v-for="(item, index) in displayedImages"
            :key="index"
            class="offer-image-item"
          >
            <Image
              class="offer-image-item__image"
              :src="item"
              alt=""
            />
            <div class="h5-offer-tool">
              <img
                src="https://cdn-image.bestdealer.com/app-bestdealer/1688/offer/offer-findsmilar-icon.svg"
                alt=""
                @click.stop="handleFind('similar', item)"
              >
            </div>
          </div>
          <div
            class="h5-offer-image-more"
            @click="toggleDescExpand"
            v-if="!isDesExpanded"
          >
            <div class="h5-offer-image-more-title">
              View More
            </div>
            <img
              src="@/assets/H5/offer/down.svg"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>
    <div class="h5-offer-footer-bg">
      <img
        src="@/assets/H5/offer/bottom-line.png"
        alt=""
      >
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useImagePreview } from '@/hooks/useImagePreview'
import { Image } from '@/components/Image'
import { buriedPointUtil } from '@/utils/utils'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { useProductDetail } from '../../hooks/useProductDetail'

const props = defineProps({
  detailInfo: {
    type: Object,
    default: () => ({})
  },
  productImages: {
    type: Array,
    default: () => []
  }
})

const { showImagePreviewWithSimilar } = useImagePreview()

const { descriptionImages } = useProductDetail()

const store = useStore()
const router = useRouter()
const route = useRoute()

const isDesExpanded = ref(false)

const displayedImages = computed(() => {
  if (isDesExpanded.value) {
    return descriptionImages.value
  }
  return descriptionImages.value.slice(0, 2)
})

const toggleDescExpand = () => {
  isDesExpanded.value = !isDesExpanded.value
}

const handleImagePreview = (index) => {
  showImagePreviewWithSimilar({
    images: displayedImages.value,
    startPosition: index,
    offerId: props.detailInfo.offerId
  })
}

const handleFind = (type, imageUrl) => {
  if (type === 'similar') {
    buriedPointUtil({ eventId: 'MPOP201' })
  } else {
    buriedPointUtil({ eventId: 'MPOP202' })
  }

  sessionStorage.setItem(`currentMainImage_${props.detailInfo.offerId}`, imageUrl)
  const url = `/search?offerId=${props.detailInfo.offerId}&type=${type}`
  if (route.fullPath.includes('imageId')) {
    router.replace(url)
  } else {
    router.push(url)
  }
}
</script>

<style lang='less' scoped>
.h5-description {
  padding: 12px;
  margin-top: 8px;
  background-color: #FFFFFF;

  .h5-offer-detail {
    .h5-offer-detail-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      font-family: mon-700;
      color: #232323;
    }

    .h5-offer-image-list {
      margin-top: 10px;
      font-size: 0px;

      .offer-image-item {
        width: 100%;
        position: relative;
        margin-top: 8px;

        &__image {
          width: 100%;
          aspect-ratio: 1 / 1;
        }

        .h5-offer-tool {
          position: absolute;
          top: 16px;
          right: 16px;
          display: flex;
          flex-direction: column;

          img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
          }

          img:nth-child(2) {
            margin-top: 12px;
          }
        }
      }
    }

    .h5-offer-image-more {
      margin-top: 12px;
      display: flex;
      align-items: center;
      justify-content: center;

      .h5-offer-image-more-title {
        font-family: mon-600;
        font-size: 12px;
        color: #6E717A;
        line-height: 16px;

        img {
          margin-left: 2px;
        }
      }
    }
  }
}

.h5-offer-footer-bg {
  display: flex;
  justify-content: center;
  padding-bottom: 104px;
  img {
    width: 188px;
    margin-top: 16px;
  }
}
</style>
